import { Content as AntContent } from "antd/es/layout/layout";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
import { OrdersHeader } from "../organisms/orders-header/OrdersHeader";
import { Col, Row } from "antd";
import { ServicesOrdersList } from "../organisms/services-orders-list/ServicesOrdersList";
import { ServiceDetailsModal } from "../molecules/service-details-modal/ServiceDetailsModal";
import { ReservationCalendarNew } from "../molecules/reservation-calenda-new/ReservationCalendarNew";
import { OrdersEmptyState } from "../organisms/orders-empty-state/OrdersEmptyState";
import { useBranchContext } from "../../contexts/branch-context";
import { useQuery } from "react-query";
import { getServicesCategories } from "../../service/client";
import { useResponsive } from "../../hooks/useResponsive";

export const Content = styled(AntContent)`
  padding: 8px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  margin: 0;
`;

const reservationTabs = [
  { key: "lista", labelKey: "lista" },
  { key: "kalendarz", labelKey: "kalendarz" },
];

export const Reservations: React.FC = () => {
  const { t } = useTranslation();
  const { currentBranch } = useBranchContext();
  const { isMobile } = useResponsive();
  const [height, setHeight] = useState(0);
  const [open, setOpen] = useState<any>(false);
  const [reservationId, setReservationId] = useState<any>(false);
  const [createReservationOpen, setCreateReservationOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("lista");

  // Sprawdź czy są usługi (empty state)
  const { data: servicesCategories, isLoading: servicesLoading } = useQuery(
    ["/services-categories"],
    () => getServicesCategories()
  );
  const hasServices = servicesCategories?.some(
    (cat: any) => cat.services?.length > 0 || cat.serviceCount > 0
  );
  const showEmptyState = !servicesLoading && !hasServices && servicesCategories !== undefined;

  return (
    <>
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          height: "100%",
          maxHeight: "100%",
          minHeight: "100%",
        }}
      >
        <OrdersHeader
          setHeight={setHeight}
          onCreateReservation={() => setCreateReservationOpen(true)}
          disableActions={showEmptyState}
          mobileTabs={
            !showEmptyState
              ? reservationTabs.map((tab) => ({
                  key: tab.key,
                  label: t(`reservationsPage.${tab.labelKey}`),
                }))
              : undefined
          }
          mobileActiveTab={activeTab}
          onMobileTabChange={setActiveTab}
        />
        <div
          style={{
            flex: "1 1 auto",
            overflow: "auto",
          }}
        >
          {showEmptyState ? (
            <OrdersEmptyState type="reservations" />
          ) : isMobile ? (
            // Mobile: show one view at a time based on active tab
            activeTab === "lista" ? (
              <ServicesOrdersList
                height={height}
                setOpen={setOpen}
                setReservationId={setReservationId}
              />
            ) : (
              <ReservationCalendarNew
                setOpen={setOpen}
                setReservationId={setReservationId}
                createReservationOpen={createReservationOpen}
                setCreateReservationOpen={setCreateReservationOpen}
              />
            )
          ) : (
            // Desktop: side-by-side layout
            <Row>
              <Col span={6}>
                <ServicesOrdersList
                  height={height}
                  setOpen={setOpen}
                  setReservationId={setReservationId}
                />
              </Col>
              <Col span={18}>
                <ReservationCalendarNew
                  setOpen={setOpen}
                  setReservationId={setReservationId}
                  createReservationOpen={createReservationOpen}
                  setCreateReservationOpen={setCreateReservationOpen}
                />
              </Col>
            </Row>
          )}
        </div>
      </div>
      <ServiceDetailsModal
        open={open}
        setOpen={setOpen}
        reservationId={reservationId}
        isOrder={false}
      />
    </>
  );
};
